<div class="container-fluid">
    <div class="row">
      <div class="col-12" style="display:flex;justify-content: flex-start;">
        <button *ngIf="caseDetails && caseDetails.settings.allowEditExternalAction && addExternalActionShow==false && editExternalActionShow==false" class="btn btn-primary m-3" (click)="openCreateModal()">
            <i class="fa fa-plus-circle"></i>
            <span> {{'AddExternalAction' | translate}} </span>
        </button>
      </div>
      <div class="col-sm-12" *ngIf="addExternalActionShow==false && editExternalActionShow==false">
        <div class="card">
          <!-- <div class="me-3 ms-2 mt-3">
            <div class="px-4 me-4">
              <div class="row justify-content-center mb-4">
                <button
                  class="col-3 btn btn-primary m-2"
                  (click)="openCreateModal(addExternalActionModal)"
                >
                  <app-feather-icons [icon]="'plus'"></app-feather-icons>
                  <b> {{ "AddExternalAction" | translate }}</b>
                </button>
              </div>
              <div></div>
            </div>
          </div> -->
          <table class="table table-striped mt-3">
            <thead class="thead-dark">
              <tr>
                <th>{{ "ProcedureType" | translate }}</th>
                <th>{{ "ConcernedParty" | translate }}</th>
                <th>{{ "ProcedureDate" | translate }}</th>
                <th>{{ "OtherConcernedParty" | translate }}</th>
                <th>{{ "Notes" | translate }}</th>
                <th>{{ "createDate" | translate }}</th>
                <th>{{"Preview" | translate}}</th>
                <th scope="col">{{"Attachments" | translate}}</th>
                <th scope="col" *ngIf="caseDetails && caseDetails.settings.allowEditExternalAction">{{ "Edit" | translate }}</th>
                <th scope="col" *ngIf="caseDetails && caseDetails.settings.allowEditExternalAction">{{ "Delete" | translate }}</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let externalAction of externalActionsArr">
                <td>{{ externalAction.procedureName }}</td>
                <td>{{ externalAction.partyName }}</td>
                <td>{{ externalAction.dateOfAction | toDateOnly }}</td>
                <td>{{ externalAction.other ?  externalAction.other : "-" }}</td>
                <td>{{ externalAction.comment }}</td>
                <td>{{ externalAction.createdOn | toDateOnly }}

                  <br />
                       
                  <span *ngIf="externalAction.creatorName!=null" style="font-size: 10px; ">{{'companyandBy'|translate}}:{{
                    externalAction.creatorName}}</span>
                  
                </td>
                <td>
                  <a (click)="externalActionPreview(externalAction,externalActionPreviewModal)">
                      <i class="fa fa-eye"></i>
                  </a>
                </td>
                <td>
                  <a (click)="externalActionAttachment(externalAction.externalActionId,AddAttachment)">
                      <i class="fa fa-files-o fa-lg"></i>
                  </a>
                </td>
                <td *ngIf="caseDetails && caseDetails.settings.allowEditExternalAction">
                  <a style="cursor: pointer;" (click)="editExternalAction(externalAction)" >
                    <i class="fa fa-edit"></i>
                  </a>
                </td>
                <td *ngIf="caseDetails && caseDetails.settings.allowEditExternalAction">
                  <a (click)="deleteExternalAction(externalAction.externalActionId, deleteModal)" style="cursor: pointer;">
                    <i class="fa fa-trash"></i>
                  </a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
</div>
<!-- add -->
 
  <div class="card p-3" *ngIf="addExternalActionShow==true">
    <div   style="justify-content: space-between">
      <h4 class="modal-title" id="modal-basic-title">
        {{ "AddExternalAction" | translate }}
      </h4>
   
    </div>
    
        <div class="custom-form">
            <div class="col-12 offset-1">
              <div class="card p-3">
                <div class="form-group row">
                    <div class="col-lg-6">
                        <div class="divformlabel">
                          <label>{{ "ProcedureType" | translate }}</label>
                          <span *ngIf="ProcedureType.invalid" class="alert" style="color: red; white-space: nowrap;line-height: 0;padding: 0; margin-top: 8px;">
                            *
                          </span>
                        </div>
                        <ng-select
                          id="ProcedureType"
                          required
                          #ProcedureType="ngModel"
                          class="form-control-select"
                          [items]="procedureArr"
                          bindLabel="text"
                          bindValue="id"
                          [(ngModel)]="procedureTypeId"
                          [ngModelOptions]="{ standalone: true }"
                          placeholder="{{ 'ProcedureType' | translate }}"
                        >
                        </ng-select>
                    </div>
                    <div class="col-lg-6">
                        <div class="divformlabel">
                        <label>{{ "ConcernedParty" | translate }}</label>
                        <span *ngIf="ConcernedParty.invalid" class="alert" style="color: red; white-space: nowrap;line-height: 0;padding: 0; margin-top: 8px;">
                            *
                        </span>
                        </div>
                        <ng-select
                        id="ConcernedParty"
                        required
                        #ConcernedParty="ngModel"
                        class="form-control-select"
                        [items]="partyArr"
                        bindLabel="text"
                        bindValue="id"
                        [(ngModel)]="partyId"
                        [ngModelOptions]="{ standalone: true }"
                        placeholder="{{ 'ConcernedParty' | translate }}"
                        >
                        </ng-select>
                    </div>
                </div>
                <div *ngIf="partyId==4" class="form-group row mt-3">
                    <div class="col-lg-12">
                        <div class="divformlabel">
                        <label>{{ "OtherConcernedParty" | translate }}</label>
                        <span *ngIf="OtherConcernedParty.invalid" class="alert" style="color: red; white-space: nowrap;line-height: 0;padding: 0; margin-top: 8px;">
                            *
                        </span>
                        </div>
                        <input
                        id="OtherConcernedParty"
                        required
                        #OtherConcernedParty="ngModel"
                        class="form-control"
                        type="text"
                        [(ngModel)]="other"
                        [ngModelOptions]="{ standalone: true }"
                        placeholder="{{ 'OtherConcernedParty' | translate }}"
                        />
                    </div>
                </div>
                <div class="form-group row mt-3">
                    <div class="col-lg-12">
                        <div style="display: flex; flex-wrap: nowrap; height: 30px">
                          <label> {{ "ProcedureDate" | translate }}</label>
                          <!-- <span *ngIf="!dateOfAction" class="alert" style="color: red; white-space: nowrap;line-height: 0;padding: 0; margin-top: 8px;">
                            *
                          </span> -->
                        </div>
                        <datepicker
                          [(selectedDate)]="currentDate"
                          (selectedDateChange)="SelectedDateChange($event)"
                          [selectedDateType]="2"
                        
                        ></datepicker>
                    </div> 
                </div>
                <div class="form-group row mt-3">
                  <div class="col-lg-12">
                    <div style="display: flex; flex-wrap: nowrap; height: 30px">
                      <label>{{ "Notes" | translate }}</label>
                      <span
                        *ngIf="Notes.invalid"
                        class="alert"
                        style="
                          color: red;
                          white-space: nowrap;
                          line-height: 0;
                          padding: 0;
                          margin-top: 8px;
                        "
                      >
                        <div *ngIf="Notes.errors?.required">*</div>
                      </span>
                    </div>
                    <textarea
                      id="Notes"
                      required
                      #Notes="ngModel"
                      class="form-control"
                      rows="2"
                      [(ngModel)]="comment"
                      [ngModelOptions]="{ standalone: true }"
                      placeholder="{{ 'Notes' | translate }}"
                    >
                    </textarea>
                  </div>
                </div>
              </div>
            </div>
        </div>

        <div class="row m-2 col-12 justify-content-center">
          <!-- || !dateOfAction  -->
          <button [disabled]="ProcedureType.invalid || ConcernedParty.invalid || (partyId==4 && !other) || Notes.invalid" (click)="AddExternalAction()" type="button" class="btn btn-primary col-lg-2 m-1" >
            {{ "Save" | translate }}
          </button>
          <!-- || !dateOfAction  -->
          <button [disabled]="ProcedureType.invalid || ConcernedParty.invalid || (partyId==4 && !other) || Notes.invalid" (click)="AddExternalActionAndClose()" type="button" class="btn btn-primary col-lg-2 m-1"  >
            {{ "Save and Back" | translate }}
          </button>
          <button type="button" class="btn btn-danger col-lg-2 m-1" (click)="addExternalActionShow=false;">
            {{ "BackLists" | translate }}
          </button>
        </div>
        <h4 class="mt-3" *ngIf="AttachShow" >{{ "Attachments" | translate }}</h4>
        <hr>
        <app-general-attachment *ngIf="AttachShow"  [ElementTypeId]="'5'" [loadDataFP]="loadfromparent"></app-general-attachment>
 
  
</div>

<!-- edit -->
<div class="card p-3" *ngIf="editExternalActionShow==true">
   
    <div  style="justify-content: space-between">
      <h4 class="modal-title" id="modal-basic-title">
        {{ "EditExternalAction" | translate }}
      </h4>
  
  
    </div>
    <div  >
        <div class="custom-form">
            <div class="col-12 offset-1">
              <div class="card p-3">
                <div class="form-group row">
                    <div class="col-lg-6">
                        <div class="divformlabel">
                          <label>{{ "ProcedureType" | translate }}</label>
                          <span *ngIf="EditProcedureType.invalid" class="alert" style="color: red; white-space: nowrap;line-height: 0;padding: 0; margin-top: 8px;">
                            *
                          </span>
                        </div>
                        <ng-select
                          id="EditProcedureType"
                          required
                          #EditProcedureType="ngModel"
                          class="form-control-select"
                          [items]="procedureArr"
                          bindLabel="text"
                          bindValue="id"
                          [(ngModel)]="editedExternalAction.procedureId"
                          [ngModelOptions]="{ standalone: true }"
                          placeholder="{{ 'ProcedureType' | translate }}"
                        >
                        </ng-select>
                    </div>
                    <div class="col-lg-6">
                        <div class="divformlabel">
                        <label>{{ "ConcernedParty" | translate }}</label>
                        <span *ngIf="EditConcernedParty.invalid" class="alert" style="color: red; white-space: nowrap;line-height: 0;padding: 0; margin-top: 8px;">
                            *
                        </span>
                        </div>
                        <ng-select
                        id="EditConcernedParty"
                        required
                        #EditConcernedParty="ngModel"
                        class="form-control-select"
                        [items]="partyArr"
                        bindLabel="text"
                        bindValue="id"
                        [(ngModel)]="editedExternalAction.partyId"
                        [ngModelOptions]="{ standalone: true }"
                        placeholder="{{ 'ConcernedParty' | translate }}"
                        >
                        </ng-select>
                    </div>
                </div>
                <div *ngIf="editedExternalAction.partyId==4" class="form-group row mt-3">
                    <div class="col-lg-12">
                        <div class="divformlabel">
                        <label>{{ "OtherConcernedParty" | translate }}</label>
                        <span *ngIf="EditOtherConcernedParty.invalid" class="alert" style="color: red; white-space: nowrap;line-height: 0;padding: 0; margin-top: 8px;">
                            *
                        </span>
                        </div>
                        <input
                        id="EditOtherConcernedParty"
                        required
                        #EditOtherConcernedParty="ngModel"
                        class="form-control"
                        type="text"
                        [(ngModel)]="editedExternalAction.other"
                        [ngModelOptions]="{ standalone: true }"
                        placeholder="{{ 'OtherConcernedParty' | translate }}"
                        />
                    </div>
                </div>
                <div class="form-group row mt-3">
                    <div class="col-lg-12">
                        <div style="display: flex; flex-wrap: nowrap; height: 30px">
                          <label> {{ "ProcedureDate" | translate }}</label>
                          <!-- <span *ngIf="!editedExternalAction.dateOfAction" class="alert" style="color: red; white-space: nowrap;line-height: 0;padding: 0; margin-top: 8px;">
                            *
                          </span> -->
                        </div>
                        <datepicker
                          (selectedDateChange)="SelectedDateChangeEdit($event)"
                          [selectedDateType]="2"
                          [(selectedDate)]="editedDate"
                        ></datepicker>
                    </div> 
                </div>
                <div class="form-group row mt-3">
                  <div class="col-lg-12">
                    <div style="display: flex; flex-wrap: nowrap; height: 30px">
                      <label>{{ "Notes" | translate }}</label>
                      <span
                        *ngIf="EditNotes.invalid"
                        class="alert"
                        style="
                          color: red;
                          white-space: nowrap;
                          line-height: 0;
                          padding: 0;
                          margin-top: 8px;
                        "
                      >
                        <div *ngIf="EditNotes.errors?.required">*</div>
                      </span>
                    </div>
                    <textarea
                      id="EditNotes"
                      required
                      #EditNotes="ngModel"
                      class="form-control"
                      rows="2"
                      [(ngModel)]="editedExternalAction.comment"
                      [ngModelOptions]="{ standalone: true }"
                      placeholder="{{ 'Notes' | translate }}"
                    >
                    </textarea>
                  </div>
                </div>
                
              </div>
            </div>
        </div>
  
        <div class="row m-2 col-12 justify-content-center">
          <!-- || !editedExternalAction.dateOfAction  -->
          <button [disabled]="EditProcedureType.invalid || EditConcernedParty.invalid || (editedExternalAction.partyId==4 && !editedExternalAction.other) || EditNotes.invalid" (click)="onEditExternalAction()" type="button" class="btn btn-primary col-lg-2 m-1" >
            {{ "Save and Back" | translate }}
          </button>
           <button type="button" class="btn btn-danger col-lg-2 m-1" (click)="editExternalActionShow=false;">
            {{ "BackLists" | translate }}
          </button>
        </div>
        <h4 class="mt-3">{{ "Attachments" | translate }}</h4>
        <hr>
        <app-general-attachment [ElementTypeId]="'5'" [loadDataFP]="loadfromparent2"></app-general-attachment>
  
    </div>
 
 
</div>


<ng-template #deleteModal let-modal>
  <div class="modal-header" style="justify-content: center">
      <h4 class="modal-title" id="modal-basic-title">
          {{ "ConfirmDeleteOperation" | translate }}
      </h4>
  </div>
  <div class="modal-body text-center">
      <p>{{ "SelectedRecordwillbeDeleted" | translate }}</p>
  </div>
  <div class="modal-footer">
      <button type="button" class="btn btn-danger" (click)="onDeleteExternalAction(modal)">
          {{ "YES" | translate }}
      </button>
      <button type="button" class="btn btn-primary" (click)="modal.dismiss('Cross click')">
          {{ "NO" | translate }}
      </button>
  </div>
</ng-template>

<ng-template #AddAttachment let-modal>
  <div class="modal-header" style="justify-content: center">
      <h4 class="modal-title" id="modal-basic-title">
          {{'Attachments'|translate}}
      </h4>
  </div>
  <div class="modal-body text-center">
      <app-general-attachment   [ElementTypeId]="'5'" [loadDataFP]="loadfromparent"></app-general-attachment>

  </div>
  <div class="modal-footer">
     
      <button type="button" class="btn btn-primary" (click)="modal.dismiss('Cross click')">
          {{ "Close" | translate }}
      </button>
  </div>
</ng-template>
<ng-template #externalActionPreviewModal let-modal>
  <div class="modal-header" style="justify-content: space-between">
    <h4 class="modal-title" id="modal-basic-title">
      {{ "PreviewExternalAction" | translate }}
    </h4>

    <i
      style="font-size: 20px"
      class="fa fa-close"
      (click)="modal.dismiss('Cross click')"
    ></i>
  </div>
  <div class="modal-body">
      <div class="custom-form">
          <div class="col-12 offset-1">
            <div class="card p-3">
              <div class="form-group row">
                  <div class="col-lg-6">
                    <label>{{ "ProcedureType" | translate }}</label>
                    <span class="form-control" readonly>{{editedExternalAction.procedureName}} &nbsp;</span>
                  </div>
                  <div class="col-lg-6">
                    <label>{{ "ConcernedParty" | translate }}</label>
                    <span class="form-control" readonly>{{editedExternalAction.partyName}} &nbsp;</span>
                  </div>
              </div>
              <div *ngIf="editedExternalAction.partyId==4" class="form-group row mt-3">
                  <div class="col-lg-12">
                    <label>{{ "OtherConcernedParty" | translate }}</label>
                    <span class="form-control" readonly>{{editedExternalAction.other}} &nbsp;</span>
                  </div>
              </div>
              <div class="form-group row mt-3">
                  <div class="col-lg-12">
                    <label> {{ "ProcedureDate" | translate }}</label>
                    <span class="form-control" readonly>{{editedExternalAction.dateOfAction | toDateOnly}} &nbsp;</span>
                  </div> 
              </div>
              <div class="form-group row mt-3">
                <div class="col-lg-12">
                  <label>{{ "Notes" | translate }}</label>
                  <span class="form-control" readonly>{{editedExternalAction.comment}} &nbsp;</span>
                </div>
              </div>
            </div>
          </div>
      </div>
  </div>
  <div class="modal-footer row" style="justify-content: flex-end; padding: 1rem 2rem" >
    <button type="button" class="btn btn-danger col-lg-3" (click)="modal.dismiss('Cross click')">
      {{ "Close" | translate }}
    </button>
  </div>
  
</ng-template>